import React from "react";
import ReactMarkdown from 'react-markdown'
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon
} from 'react-share'
import PropTypes from 'prop-types'
import { Layout, Carousels } from '../../components'
import DynamicZone from '../../helpers/dynamicZone'
import { getDateFormatted } from "../../helpers/getDateFormatted";
import moment from "moment";
import "./novelty.scss"

const Novelty = ({ pageContext, data }) => {
  // pageContext - Elementos pasados como parametros
  // data - Información obtenida de la query
  
  const { 
    noveltyId,
    noveltyData,
    navbar,
    footerData
  } = pageContext

  const { title, header, summary, date, content, components, pageMetadata, novelties_categories } = noveltyData;

  const objDate = getDateFormatted(date);
  const year = moment(date).format('YYYY'); 

  let shareUrl = ''
  if (typeof window !== 'undefined') {
    shareUrl = window.location.href
  }

  return (
    <Layout
      key={`novelty-${noveltyId}`}
      screenData={navbar}
      pageMetadata={pageMetadata}
      footerData={footerData}
    >
      {header !== null && (
        <Carousels carousel={header} keyName={`noveltyPage-${noveltyId}`} />
      )}

      <div className="container novelties-container w-100 py-5">
        <div className="publication-social-container">
          <div className="publication">
            <p className="text-block">
              Publicado el {objDate.numberDay} de {objDate.month } de {year }{" en "}
              <b>
              {novelties_categories.map((category, i) => { 
                if ((novelties_categories.length - 1) > i) {
                  return category?.name + " - "
                } else {
                  return category?.name
                }
              })}
            </b>
            </p>
          </div>
          <div className="social-medias justify-content-end">
            <FacebookShareButton
              url={shareUrl}
              quote={title}
              className="me-1"
            >
            <FacebookIcon size={32} round />
            </FacebookShareButton>
            <TwitterShareButton
              url={shareUrl}
              title={title}
              className="me-1"
            >
              <TwitterIcon size={32} round />
            </TwitterShareButton>
            <LinkedinShareButton url={shareUrl} className="me-1">
              <LinkedinIcon size={32} round />
            </LinkedinShareButton>
          </div>
        </div>
      
        <h1 className="novelty-title mb-4">{title}</h1>
      
        <div className="mb-5">
          <p className="novelty-summary pb-4">
            {summary}
          </p>
          <ReactMarkdown
            renderers= {{link: ({node, ...props}) => <a {...props} target="_blank" rel="noopener noreferrer"/>}}
            children={content}
            rehypePlugins={false}
            className="format-markdown-container markdown-format fade-in-image"
          />
        </div>
      </div>
      
      <DynamicZone components={components} />
    </Layout>
  );
};

Novelty.propTypes = {
  pageContext: PropTypes.object.isRequired,
}

export default Novelty;